<template>
  <div>
    <div class="dataTour">
      <div>{{$t('name')}}</div>
      <div>{{tournament ? getName(tournament.name) : '-'}}</div>
      <div>{{$t('participantsQuantity')}}</div>
      <div>{{currentParticipants}} / {{tournament.numberParticipants}}</div>
      <div>{{$t('type')}}</div>
      <div>{{tournamentType}}</div>
      <div>{{$t('participants')}}</div>
      <div>
        <v-chip
          v-for="(participant, index) of participants"
          color="primary"
          small
          dark
          class="body-2"
          :key="index+233"
        >{{participant}}</v-chip>
        <!-- {{participants}} -->
      </div>
      <div>{{$t('dates')}}</div>
      <div>{{dateFormat(tournament.startAt)}} - {{dateFormat(tournament.endAt)}}</div>
      <div>{{$t('location')}}</div>
      <div>{{findStadium(tournament.stadiumId)}}</div>
      <div>{{$tc('act')}}</div>
      <div>
        {{tournament ? tournament.actName : '-'}}
        <v-btn color="primary" small @click="viewAct()" :loading="loadingAct">{{$t('openAct')}}</v-btn>
      </div>
      <div>{{$tc('description')}}</div>
      <div>{{tournament ? getName(tournament.description) : '-'}}</div>
    </div>
    <act-view @close="closeView()" :modal="viewModal" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { dateFormat } from '../../../../helpers/dateHelper'
import actView from '../../../management/acts/ActsView'

export default {
  name: 'tabInformacion',
  components: {
    actView
  },
  props: {
    tournament: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      viewModal: false
    }
  },
  computed: {
    ...mapState({
      actas: state => state.acts.list,
      loadingAct: state => state.acts.loading,
      stadiums: state => state.stadiums.listStadiums,
      teams: state => state.teams.listTeams,
      users: state => state.users.listaUsers
    }),
    currentParticipants() {
      let current = 0
      if (this.tournament.type === 'users') {
        if (this.tournament.users) {
          current = this.tournament.users.filter(
            item => item.confirmed && item.accepted
          ).length
        }
      }
      if (
        this.tournament.type == 'teams' ||
        this.tournament.type == 'usersTeams'
      ) {
        if (this.tournament.teams) {
          current = this.tournament.teams.filter(
            item => item.confirmed && item.accepted
          ).length
        }
      }
      return current
    },
    participants() {
      let result = []
      if (this.tournament.type === 'users') {
        this.tournament.users.forEach(item => {
          result.push(item.name)
        })
      }
      if (
        this.tournament.type === 'teams' ||
        this.tournament.type === 'usersTeams'
      ) {
        this.tournament.teams.forEach(item => {
          result.push(item.name)
        })
      }
      return result
    },
    tournamentType() {
      if (!this.tournament || !this.tournament.type) return ''
      let type = this.tournament.type
      if (type == 'users') return this.$tc('user', 2)
      else if (type == 'teams') return this.$tc('team', 2)
      else return this.$t(type)
    }
  },
  methods: {
    ...mapActions({
      getOne: 'acts/setOne',
      setClearOne: 'acts/setClearOne'
    }),
    findActa(id) {
      let result = this.actas.find(item => item._id === id)
      return result || {}
    },
    findStadium(id) {
      if (!id || !Array.isArray(id)) {
        return []
      }
      let result = []
      id.forEach(element => {
        let temporalStadium = this.stadiums.find(item => item._id === element)
        if (temporalStadium) {
          result.push(temporalStadium.name)
        }
      })
      return result ? result.join() : ''
    },
    findTeam(id) {
      let result = this.teams.find(item => item._id === id)
      return result || ''
    },
    dateFormat(date) {
      return dateFormat(date, false)
    },
    closeView() {
      this.nextTick(_ => {
        this.viewModal = false
      })
    },
    viewAct() {
      this.setClearOne()
      this.getOne(this.tournament.act).then(_ => {
        this.viewModal = true
      })
    }
  }
}
</script>

<style scoped lang="scss">
.dataTour {
  display: grid;
  width: 100%;
  grid-template-columns: 30% auto;

  div {
    padding: 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  }
}
</style>
